import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      // Use the same open() path as the manual trigger so any open-time bindings run consistently (important on iOS/Safari).
      this.open();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    const dialogEl = this.refs.dialog;
    if (dialogEl instanceof HTMLElement) {
      dialogEl.style.pointerEvents = '';
      dialogEl.style.zIndex = '';
    }

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const termsEl = dialogEl?.querySelector?.('shopify-payment-terms');
      if (!termsEl) return;

      // Defer closing drawer to avoid blocking Shopify's modal
      const safeCloseOnce = () => {
        if (dialogEl instanceof HTMLElement) {
          dialogEl.style.pointerEvents = 'none';
          dialogEl.style.zIndex = '0';
        }
        setTimeout(() => this.closeDialog(), 0);
      };

      // iOS/Safari: shadow DOM CTA may not exist yet; events retarget to the host.
      termsEl.addEventListener('click', safeCloseOnce, { once: true, capture: true });

      // Best-effort direct CTA binding when available.
      const installmentsContent = termsEl.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', safeCloseOnce, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
